module.exports = __webpack_public_path__ + "img/plus-mint-nor-24.12bc4b30.svg";